<template>
  <div class="teacher_data">
    <!-- Start Main Loader -->

    <!-- End Main Loader -->
    <div class="personal_data_wrapper fadeIn">
      <!-- <div class="ml-3 pb-3 d-flex w-100 justify-content-end">
        <v-btn
          @click="toggleStatusModel"
          class="px-10"
          :color="userInfo.is_ban ? 'error' : 'success'"
          >{{ userInfo.is_ban ? "محظور" : "غير محظور" }}</v-btn
        >
      </div> -->
      <div class="order-details-page mb-5">
        <div class="row py-2 mx-1 justify-content-center align-items-center">
          <div class="col-12">
            <div class="details border-right-0">
              <div class="row">
                <div class="col-sm-6 pt-0">
                  <div class="customer">
                    <div class="item">
                      <div class="info">
                        <h5 class="title">
                          {{ $t("forms.labels.name") }}
                        </h5>
                        <p>
                          {{ userInfo.name }}
                        </p>
                      </div>
                      <div class="icon">
                        <i class="fal fa-user"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 pt-0" v-if="userInfo.desc">
                  <div class="customer">
                    <div class="item">
                      <div class="info">
                        <h5 class="title">
                          {{ $t("forms.labels.desc") }}
                        </h5>
                        <p>{{ userInfo.desc }}</p>
                      </div>
                      <div class="icon">
                        <i class="fal fa-pen"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 pt-0" v-if="userInfo.place">
                  <div class="customer">
                    <div class="item">
                      <div class="info">
                        <h5 class="title">
                          {{ $t("forms.labels.place") }}
                        </h5>
                        <p>{{ userInfo.place.name }}</p>
                      </div>
                      <div class="icon">
                        <i class="fal fa-pen"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 pt-0" v-if="userInfo.country">
                  <div class="customer">
                    <div class="item">
                      <div class="info">
                        <h5 class="title">
                          {{ $t("forms.labels.country") }}
                        </h5>
                        <p>
                          {{ userInfo.country.name }}
                        </p>
                      </div>
                      <div class="icon">
                        <i class="fal fa-globe"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 pt-0" v-if="userInfo.menu">
                  <div class="customer">
                    <div class="item">
                      <div class="info">
                        <h5 class="title">
                          {{ $t("forms.labels.menu") }}
                        </h5>
                        <p>
                          {{ userInfo.menu.ar.name }} -
                          {{ userInfo.menu.en.name }}
                        </p>
                      </div>
                      <div class="icon">
                        <i class="fal fa-list"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 pt-0">
                  <div class="customer">
                    <div class="item">
                      <div class="info">
                        <h5 class="title">مفعل ؟</h5>
                        <p>{{ userInfo.is_active ? "مفعل" : "غير مفعل" }}</p>
                      </div>
                      <div class="icon">
                        <i class="fal fa-user-check"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 pt-0">
                  <div class="customer">
                    <div class="item">
                      <div class="info">
                        <h5 class="title">المقاسات</h5>
                        <p v-for="(size, i) in userInfo.sizes" :key="size.id">
                          {{ size.name }}
                          <br />
                          {{ size.price }} {{ size.currency }}
                          <span v-if="i != 0">
                            <hr />
                          </span>
                        </p>
                      </div>
                      <div class="icon">
                        <i class="fal fa-user-check"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 pt-0">
                  <div class="customer">
                    <div class="item">
                      <div class="info">
                        <h5 class="title">الأضافات</h5>
                        <p
                          v-for="(addition, i) in userInfo.additions"
                          :key="addition.id"
                        >
                          {{ addition.name }}
                          <br />
                          {{ addition.price }} {{ addition.currency }}
                          <span v-if="i != 0">
                            <hr />
                          </span>
                        </p>
                      </div>
                      <div class="icon">
                        <i class="fal fa-user-plus"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 pt-0">
                  <div class="customer">
                    <div class="item">
                      <div class="info">
                        <h5 class="title">الصور</h5>
                        <div class="profile_header_data" v-if="userInfo.images">
                          <div
                            v-for="image in userInfo.images"
                            :key="image.id"
                            class="avatar_wrapper ms-2"
                          >
                            <img
                              :src="image.url"
                              width="100"
                              height="100"
                              alt="Avatar"
                              class="rounded-circle"
                            />
                          </div>
                        </div>
                      </div>
                      <!-- <div class="icon">
                        <i class="fal fa-user-plus"></i>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["userInfo"],

  data() {
    return {
      center: {},
      markers: null,
      coordinates_to_edit: { lat: 0, lng: 0 },
      ban_reason: null,
      statusLoading: false,
      acceptLoading: false,
      acceptModel: false,
      statusModel: false,
    };
  },

  computed: {
    isActive() {
      return this.userInfo.is_active ? this.$t("active") : this.$t("inactive");
    },

    isBan() {
      return this.userInfo.is_ban ? this.$t("ban") : this.$t("inban");
    },
    isActiveManager() {
      return this.userInfo.is_ban ? "غير مفعل" : " مفعل";
    },
  },

  methods: {
    // ============== Get User Location
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          // this.$axios({
          //   method: "get",
          //   url: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=AIzaSyAITrPfT5r_qmCm_8ekZyPmnebGo8o_r18`,
          // })
          //   .then((res) => {
          //     console.log(res.data.results[0].formatted_address);
          //   })
          //   .catch(() => {});
          console.log(position);

          this.markers = [
            {
              position: {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              },
            },
          ];
          this.center = this.markers[0].position;
          this.coordinates_to_edit.lat = this.center.lat;
          this.coordinates_to_edit.lng = this.center.lng;
        });
      }
    },
    toggleStatusModel() {
      this.statusModel = true;
    },
    changeStatus() {
      if (!this.userInfo.is_ban && !this.ban_reason) {
        this.$iziToast.error({
          message: "يرجي ادخال سبب الغاء الحظر اولا",
          timeout: 5000,
          position: "bottomRight",
        });
        return;
      }
      this.statusLoading = true;
      const formData = new FormData();
      formData.append("is_active", this.userInfo.is_ban ? 0 : 1);
      if (this.ban_reason) {
        formData.append("message", this.ban_reason);
      }
      formData.append("_method", "PUT");

      this.$axios({
        method: "POST",
        url: `/company/is_active/${this.userInfo.id}`,
        data: formData,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 5000,
            message: res.data.message,
            position: "bottomRight",
          });
          this.statusModel = false;
          this.$emit("get_item");
          this.ban_reason = null;
          this.statusLoading = false;
        })
        .catch(() => {
          this.loading = false;
          this.loaderPage = false;
          this.statusLoading = false;
        });
    },
  },
  created() {
    this.getLocation();
  },
};
</script>

<style>
.border-right-0 {
  border-right-width: 0 !important;
}
</style>
